import { take } from 'rxjs';

import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { organisationStatusBackground } from '@organisations/classes/utilities';
import { IUserAndOrganisationUser, OrganisationMemberStatus } from '@organisations/models/organisation-user';
import { IOrganisation } from '@organisations/models/organisations';
import { OrganisationUserService } from '@organisations/services/organisation-user/organisation-user.service';
import { ConfirmationModalComponent } from '@shared/components/modals/confirmation-modal/confirmation-modal.component';
import { MobileNumberPipe } from '@shared/pipes/mobile-number.pipe';
import { ModalService } from '@shared/services/modal/modal.service';

import { AddUserModalComponent } from '../modals/add-user-modal/add-user-modal.component';
import { EditUserModalComponent } from '../modals/edit-user-modal/edit-user-modal.component';

@Component({
	selector: 'app-desktop-org-users-table',
	imports: [CommonModule, MobileNumberPipe],
	templateUrl: './desktop-org-users-table.component.html',
	styleUrl: './desktop-org-users-table.component.scss',
})
export class DesktopOrgUsersTableComponent {
	@Input() organisationMembers: Array<IUserAndOrganisationUser>;
	@Input() organisation: IOrganisation;
	OrganisationMemberStatus = OrganisationMemberStatus;

	private modalService = inject(ModalService);
	private organisationUserService = inject(OrganisationUserService);

	openInviteUser(): void {
		this.modalService.open(AddUserModalComponent);
	}

	openEditUser(member: IUserAndOrganisationUser): void {
		const modelRef = this.modalService.open(EditUserModalComponent);
		const componentInstance = modelRef.componentInstance as EditUserModalComponent;
		componentInstance.userAndOrganisationUser = member;
		componentInstance.organisation = this.organisation;
	}

	removeOrganisationUserAction(member: IUserAndOrganisationUser): void {
		const modalRef = this.modalService.open(ConfirmationModalComponent, false, 'md');
		const componentInstance = modalRef.componentInstance as ConfirmationModalComponent;
		componentInstance.title = 'Are you sure you want to remove this member from your organisation?';
		componentInstance.contentText = member.user.displayName!;
		componentInstance.confirmAction.pipe(take(1)).subscribe(() => {
			if (member.organisationUser.id) {
				this.organisationUserService.removeUserFromOrganisation(member.organisationUser.id);
			}
		});
	}

	organisationStatusBackground(member: IUserAndOrganisationUser) {
		return organisationStatusBackground(member);
	}
}
